<template>
  <div class="modal is-active">
    <div class="modal-background" @click="dismiss()"></div>
    <div class="modal-content">
      <div class="box">
        <div class="hours">
          Mon. - Fri., 10AM - 8PM
        </div>
        <div class="email-description">
          <span class="icon">
            <i class="fa fa-envelope-o"></i>
          </span>
          Get in touch via email, we'll be sure to respond within 48 hours.
        </div>
        <div class="email">
          <a :href="`mailto:${email}`">{{ email }}</a>
        </div>
        <button class="modal-close is-large close" @click="dismiss()"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      email: 'sales@adikteev.com',
    };
  },
  methods: {
    dismiss() {
      this.$emit('dismiss');
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal-background {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .box {
    width: auto;
    height: auto;
    border-radius: 0;
    text-align: center;
    color: #FFF;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .close {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .hours {
    color: #89888A;
  }

  .email-description {
    padding: 8px 0;
    font-weight: 600;
  }

  .email {
    text-decoration: underline;
    a {
      color: #FFF;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?2ea6b1c3